import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">Privacy Policy</h1>
      
  
      
      
      
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-3 text-gray-700">Data Storage and Security</h2>
        <ul className="list-disc pl-6 mb-3">
          <li className="mb-2">All data is stored <strong>securely</strong> and is not shared with third parties</li>
          <li className="mb-2">We implement industry-standard security measures to protect your data</li>
          <li className="mb-2">We adhere to LinkedIn's <strong>Developer Terms and Privacy Guidelines</strong></li>
        </ul>
      </div>
      
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-3 text-gray-700">User Control & Consent</h2>
        <p className="mb-3">Users have full control over their data:</p>
        <ul className="list-disc pl-6 mb-3">
          <li className="mb-2"><strong>Opt-in Required:</strong> Users must explicitly upload and grant permission for data processing</li>
          <li className="mb-2"><strong>Transparency:</strong> We clearly communicate what data is processed and how it's used</li>
        </ul>
      </div>
      
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-3 text-gray-700">Compliance with LinkedIn Policies</h2>
        <p className="mb-3">
          We comply with LinkedIn's <a href="https://www.linkedin.com/legal/user-agreement" className="text-blue-500 underline">User Agreement</a> and 
          <a href="https://developer.linkedin.com/legal/api-terms-of-use" className="text-blue-500 underline"> API Terms</a>. 
          We specifically do not engage in:
        </p>
        <ul className="list-disc pl-6 mb-3">
          <li className="mb-2"><strong>No automated scraping or data extraction</strong> from LinkedIn</li>
          <li className="mb-2"><strong>No unauthorized automation</strong> of connection requests or messages</li>
          <li className="mb-2"><strong>No sharing of LinkedIn data</strong></li>
          <li className="mb-2"><strong>No retention of data</strong> beyond what is necessary for the service</li>
        </ul>
      </div>
      
    
      
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-3 text-gray-700">Updates to Privacy Policy</h2>
        <p className="mb-3">
          We may update this Privacy Policy from time to time. We will notify users of any significant changes and obtain consent where required.
        </p>
      </div>
      
      
    </div>
  );
};

export default PrivacyPolicy;